// openQuickpayModal.js
'use strict';
import { MERGE_OPERATION_DATA } from '../ActionTypes.js';
import { SHOP_ID } from '../resource/shopConstants.js';
import { addvalue } from '../resource/modalId.js';

import getMeData from '../selector/getMeData.js';

import toggleModal from '../action/toggleModal.js';

const openQuickpayModal =
  ({ sectionId } = {}) =>
  async (dispatch, getState) => {
    const isAuthed = !!getMeData(getState(), 'id');
    dispatch({
      type: MERGE_OPERATION_DATA,
      payload: {
        selectPath: ['shop'],
        data: { usingShopId: SHOP_ID.addvalue },
      },
    });
    dispatch({
      type: MERGE_OPERATION_DATA,
      payload: {
        selectPath: ['shop', SHOP_ID.addvalue],
        data: { quickpaySectionId: sectionId },
      },
    });
    return dispatch(
      toggleModal({
        modalId: isAuthed
          ? addvalue.QUICKPAY
          : addvalue.QUICKPAY_AUTH_OPTION_MODAL,
        isOpen: true,
        modalOption: {
          isHigherThanAll: true,
          transitionStatus: 'coming',
        },
      })
    );
  };

export default openQuickpayModal;
